import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { ChatMainView } from '@/core/chat/chat-view';
import { useState } from 'react';

export default function ChatDrawer({ fullWidth = true }: { fullWidth?: boolean }) {
  const [hidden, setHidden] = useState(true);

  const styles = fullWidth
    ? {
        width: '100%',
        borderTop: '1px solid gray',
        zIndex: 1000,
      }
    : {
        width: '400px',
        borderRadius: '10px 0 0 0',
        borderLeft: '1px solid grey',
        borderTop: '1px solid gray',
        zIndex: 1047,
      };

  return (
    <div
      className={'position-fixed bg-primary p-2 '}
      style={{
        bottom: 0,
        right: 0,
        ...styles,
      }}
    >
      <div
        className={'ps-1 pe-1  fw-bold d-flex align-items-center'}
        onClick={() => setHidden(!hidden)}
      >
        Chat
        <div className={'ms-auto'}>
          <Button size={'sm'}>
            {hidden && <FontAwesomeIcon icon={faPlus} />}
            {!hidden && <FontAwesomeIcon icon={faMinus} />}
          </Button>
        </div>
      </div>
      <div style={{ height: '400px' }} className={hidden ? 'd-none' : 'pt-1'}>
        <ChatMainView onNewMessage={() => setHidden(false)} />
      </div>
    </div>
  );
}
